import React from 'react';
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Session from "../helpers/Session";
import {Link} from "react-router-dom";
import Notifications from "./Notifications";

class AppMenuRight extends React.Component {

    state = {
        anchorEl: null,
    };

    handleClick = event => {
        this.setState({
            anchorEl: event.currentTarget
        });
    };

    handleClose = () => {
        this.setState({
            anchorEl: null
        });
    };

    render() {

        const open = Boolean(this.state.anchorEl);

        if (Session.getLogin()) {
            return (
                <span>

                    <Notifications/>

                    <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={this.handleClick}
                    >
                        <MoreVertIcon style={{color: '#FFFFFF'}}/>
                    </IconButton>
                    <Menu
                        id="long-menu"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        open={open}
                        onClose={this.handleClose}
                        PaperProps={{
                            style: {
                                maxHeight: 48 * 4.5,
                                width: '20ch',
                            },
                        }}
                    >
                        <MenuItem component={Link} to='/update-profile' key='update-profile'>
                            Actualizar datos
                        </MenuItem>
                        <MenuItem component={Link} to='/change-password' key='change-password'>
                            Cambiar contraseña
                        </MenuItem>
                        <MenuItem component={Link} to='/login' key='salir' onClick={Session.logout}>
                            Salir
                        </MenuItem>
                    </Menu>
                </span>
            )
        } else {
            return (null)
        }
    }

}

export default AppMenuRight